import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Text } from '@topconagriculture/react-components';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles(() => ({
    legendWrapper: { height: 30, width: '100%', paddingRight: 30, position: 'relative' },
    legend: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        justifyContent: 'end',
        zIndex: 9999,
    },
    circle: {
        borderRadius: '50%',
        border: '2px solid #000',
        width: 24,
        height: 24,
        position: 'relative',
        '& span': {
            top: -4,
            left: 5,
            position: 'absolute',
            fontSize: 18,
        },
    },
    label: {
        position: 'absolute',
        top: 5,
        left: 35,
    },
}));
export const AlertBarChartLegend = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.legendWrapper },
            React.createElement("span", { className: classes.label }, "%"),
            React.createElement("span", { className: classes.legend },
                React.createElement(Text, null, `# ${t('widget:load_deviation:chart_legend')}`),
                React.createElement("div", { className: classes.circle },
                    React.createElement("span", null, "#"))))));
};
//# sourceMappingURL=AlertBarChartLegend.js.map